export const LOGIN = 'App Logged In';
export const LOGOUT = 'App Logged Out';
export const COMPLETED_WIZARD = 'Completed Commissions Wizard';
export const MODIFIED_COMMISSION_PLANS = 'Modified Commission Plans';
export const DOWNLOAD_COMMISSIONS_REPORT = 'Download Commissions Report';
export const APPROVED_PRODUCER_COMMISSION_STATEMENT = 'Approved Producer Commission Statement';
export const FINALIZED_COMMISSION_STATEMENT = 'Finalized Commission Statement';
